import React, {useEffect, useRef} from 'react';
import SensorStatus from "../SensorStatus";
import Placement from "./Placement";
import styled from "styled-components";
import useZibi from "../../zibi/UseZibi";
import {LoaderStyled} from "../alerts/inventoryManagementAlerts/invCommonStyles";
import {api} from "../../maps/data";

const SensorStyled = styled.div`
    transition: box-shadow 150ms cubic-bezier(0.694, 0.0482, 0.335, 1) 0s, transform 150ms cubic-bezier(0.694, 0.0482, 0.335, 1) 0s;

    box-shadow: rgba(0, 0, 0, 0.2) 0px 7px 8px -4px, rgba(0, 0, 0, 0.14) 0px 12px 17px 2px, rgba(0, 0, 0, 0.12) 0px 5px 22px 4px;

    &:hover {
        box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 5px, rgba(0, 0, 0, 0.07) 0px 3.6px 13px, rgba(0, 0, 0, 0.06) 0px 8.4px 23px, rgba(0, 0, 0, 0.05) 0px 23px 35px;
        transform: translateY(-2px);
    }
`;

const SensorDataStyled = styled.div`
    position: relative;
`;

const SensorMetaDataStyled = styled.div`
    height: 20px;
    font-size: 11px;
    padding: 0 10px;
    display: grid;
    align-items: center;
    position: relative;
`;


const SensorWithPlacements = ({sensor, placements = [], invalidPlacements = [], isTest = false}) => {
    const ref = useRef(null);

    const [sensorStatuses] = useZibi('sensorStatuses');
    const [productsById, set_productsById] = useZibi('productsById');

    const getProducts = async (productIds) => {
        const filteredProductIds = [];
        productIds.forEach((id) => {
            if (!productsById[id]) {
                filteredProductIds.push(id);
            }
        });

        if (filteredProductIds?.length > 0) {
            api({
                type: 'getProducts', data: {productIds: filteredProductIds, ignoreCategory: true, page: 0}
            }).then(({products}) => {
                const temp = {};
                for (let i = 0; i < products.length; i++) {
                    const product = products[i];
                    temp[product.barcode] = product;
                    productsById[product._id] = product;
                }
                set_productsById({...productsById});
            });
        }
    };

    useEffect(() => {
        if (placements?.length || invalidPlacements?.length) {
            const ids = new Set();
            placements?.forEach((placement) => {
                if(placement.layers) {
                    if (placement.layers.length > 0) {
                        for(let layer of placement.layers) {
                            ids.add(layer.productId);
                        }
                    }
                } else {
                    if (placements.productId) {
                        ids.add(placement.productId);
                    }
                }
            });
            invalidPlacements?.forEach((placement) => {
                if (invalidPlacements.productId) {
                    ids.add(placement.productId);
                }
            });

            if (ids.size > 0) {
                getProducts(Array.from(ids));
            }
        }
    }, []);

    useEffect(() => {
        if (ref?.current && ref?.current?.offsetWidth) {
            console.log("ref?.current?.offsetWidth", ref?.current?.offsetWidth);
            console.log("ref?.current?.offsetHeight", ref?.current?.offsetHeight);

        }
    }, [ref?.current]);


    const sensorStatusData = sensorStatuses[sensor?._id];

    const status = sensorStatusData?.status;
    const statusUpdateAt = sensorStatusData?.statusUpdateAt;

    let sensorWidth = (sensor?.width || 96) * 2;
    let sensorHeight = (sensor?.height || 35) * 2;

    if (isTest) {
        sensorWidth = sensorWidth * 8;
        sensorHeight = sensorHeight * 8;
    }
    const boxHeight = sensorHeight + 20;


    const loading = !!!sensor;

    return (
        <SensorStyled ref={ref} style={{width: sensorWidth, height: boxHeight}}>
            {loading && (
                <LoaderStyled/>
            )}
            {!loading && (
                <>
                    <SensorMetaDataStyled>
                        {sensor.boardId}
                        <SensorStatus status={status} statusUpdateAt={statusUpdateAt}/>
                    </SensorMetaDataStyled>
                    <SensorDataStyled style={{width: sensorWidth, height: sensorHeight}}>
                        {placements.map((placement, index) => {
                            return (
                                <Placement
                                    products={productsById}
                                    item={placement}
                                    key={index}
                                />
                            );
                        })}
                        {invalidPlacements.map((placement, index) => {
                            return (
                                <Placement
                                    products={productsById}
                                    item={placement}
                                    key={index}
                                    color="red"
                                />
                            );
                        })}
                    </SensorDataStyled>
                </>
            )}
        </SensorStyled>
    );
};

export default SensorWithPlacements;